"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Operators = {
    MultiplicationOperators: 'MultiplicationOperators',
    AdditionOperators: 'AdditionOperators',
    TildeToken: 'TildeToken',
    LessThan: 'LessThan',
    Equal: 'Equal',
    AmountMore: 'AmountMore',
    AmountLess: 'AmountLess',
    OverThan: 'OverThan',
    LogicalJoinOperators: 'LogicalJoinOperators',
};
exports.RelationalOperatorTokens = [
    exports.Operators.LessThan,
    exports.Operators.Equal,
    exports.Operators.AmountMore,
    exports.Operators.AmountLess,
    exports.Operators.OverThan,
];
exports.RangeOperatorTokens = [
    exports.Operators.TildeToken,
];
exports.LogicalOperatorTokens = [
    exports.Operators.LogicalJoinOperators,
];
